import React from "react";
import { Box, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import { BORDER, TEXT_PRIMARY, TEXT_SECONDARY } from "../constants";

export const STATUSES = {
  unchanged: { label: "ללא שינוי", color: "#64748b", bg: "transparent" },
  moved: { label: "שינוי מיקום", color: "#475467", bg: "transparent", dotted: true },
  added: { label: "נוסף", color: "#166534", bg: "#dcfce7" },
  removed: { label: "הוסר", color: "#991b1b", bg: "#fee2e2" },
  renamed: { label: "שינוי שם", color: "#7a3e00", bg: "#fcefd6" },
  case: { label: "רישיות", color: "#1d4ed8", bg: "#eff6ff" },
};

export const InciStatusTag = ({ status: key }) => {
  const status = STATUSES[key] || STATUSES.unchanged;
  return (
    <Box
      component="span"
      sx={{ px: 0.9, py: 0.2, borderRadius: 1, bgcolor: status.bg, color: status.color, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", borderBottom: status.dotted ? "2px dotted #667085" : "none" }}
    >
      {status.label}
    </Box>
  );
};

const cellSx ={ fontSize: 13, borderBottom: `1px solid ${BORDER}`, py: 0.75 };
const headSx = { ...cellSx, color: TEXT_SECONDARY, fontWeight: 600, bgcolor: "#fafbfc", whiteSpace: "nowrap" };

/** Full ingredient-by-ingredient INCI comparison (spec 3.6) */
const InciTable = ({ rows }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell sx={headSx}>מקום לפני</TableCell>
        <TableCell sx={headSx}>רכיב בגרסה הקודמת</TableCell>
        <TableCell sx={headSx}>מקום אחרי</TableCell>
        <TableCell sx={headSx}>רכיב בגרסה המעודכנת</TableCell>
        <TableCell sx={headSx}>סטטוס</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.map((row, index) => {
        const unchanged = row.status === "unchanged";
        const ingredientSx = { ...cellSx, color: unchanged ? TEXT_SECONDARY : TEXT_PRIMARY, fontWeight: unchanged ? 400 : 600 };
        return (
          <TableRow key={index} sx={{ "&:last-of-type td": { borderBottom: 0 } }}>
            <TableCell sx={{ ...cellSx, color: TEXT_SECONDARY }}>{row.beforePosition ?? "—"}</TableCell>
            <TableCell sx={ingredientSx} dir="ltr">
              {row.before || "—"}
            </TableCell>
            <TableCell sx={{ ...cellSx, color: TEXT_SECONDARY }}>{row.afterPosition ?? "—"}</TableCell>
            <TableCell sx={ingredientSx} dir="ltr">
              {row.after || "—"}
            </TableCell>
            <TableCell sx={cellSx}>
              <InciStatusTag status={row.status} />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

export default InciTable;
